<template>
  <div :class="{ panel: true, selected }" @click="$emit('input', optionValue)">
    <div class="panel-left mr-10">
      <input
        type="radio"
        :id="optionValue"
        :value="optionValue"
        v-bind="$attrs"
        v-on="listeners"
        :checked="selected"
      />
    </div>
    <div class="panel-main">
      <p class="mb-5">
        <strong>{{ title }}</strong>
      </p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    inheritAttrs: false,

    props: {
      value: {
        type: [String, Number, Boolean],
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      optionValue: {
        type: [String, Number, Boolean],
        default: '',
      },
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          input: (e) => this.$emit('input', e.target.value),
        };
      },
      selected() {
        return this.value === this.optionValue;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .panel {
    border: 2px solid lightgray;
    border-radius: 5px;
    padding: 10px;
    display: flex;

    &:hover {
      cursor: pointer;
      border-color: grey;
    }

    & .selected {
      border-color: #0073ad;
    }
  }
</style>
